import { ClickTracking, CookieMessage, Gallery } from './components';

class App {
    constructor() {
        // Not on `load`: the theme's loading screen and video/images can hold that back for
        // seconds, and a download clicked before it fires would go uncounted.
        ClickTracking.init('body');

        window.addEventListener('load', () => {
            CookieMessage.init('.js-cookie-message');
            Gallery.init('.js-gallery');
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new App();
});
